var map = {
	"./assets/clickable/globe.svg": "eb7c4ed0c4fe5aae8fea",
	"./assets/disabled/globe.svg": "f65517a9029252317031",
	"./assets/original/globe.svg": "251cb70489d7547a3c5f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67ec82071be89eaa5ec8";